<template>
  <v-row justify="center">
    <v-expansion-panels inset>
      <v-expansion-panel
        v-for="(analysis, index) in chartControleAnalyses"
        :key="index"
      >
        <v-expansion-panel-header>
          {{ analysis.analysisType.name[userLang] || analysis.analysisType.name[teamMainLang] }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ChartItemContent
            :analysis="analysis"
            :analysisTypeId="analysis.analysisType.id"
            :analyticProcedures="analyticProcedures"
            :correctiveProcedures="correctiveProcedures"
            :controlChart="controlChart"
            :charts="chartsToUpdate"
            :chart="getChart(analysis)"
            @sendData="updateData"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>
<script>
import { mapGetters } from 'vuex';
import ChartItemContent from '@/components/nodes/controlChart/ChartItemContent.vue';
import { cloneDeep } from 'lodash';

export default ({
    components: {
        ChartItemContent,
    },
    props: {
        node: {
            type: Object,
            default: null,
        },
        controlChart: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            analyticProcedures: [],
            correctiveProcedures: [],
            data: [],
            emptyChart: {
                analyticProcedure: null,
                analysisType: null,
                siteControlled: false,
                actions: [{
                    chartAction: null,
                    correctiveProcedure: null,
                    norms: {
                        low: false,
                        veryLow: false,
                        high: false,
                        veryHigh: false,
                    },
                }],
            },
            chartsToUpdate: [],
        };
    },
    computed: {
        ...mapGetters(['chartControleAnalyses', 'userLang', 'teamMainLang']),
    },
    watch: {
        chartControleAnalyses: {
            async handler() {
                const charts = [];
                // chart with all property as objectId
                const cleanCharts = this.controlChart?.charts?.map(({ analysisType, siteControlled, analyticProcedure, actions }) => {
                    const cleanActions = [];
                    if (actions && actions.length) {
                        actions.forEach(({ chartAction, correctiveProcedure, norms }) => cleanActions.push(
                            { chartAction: chartAction?.id, correctiveProcedure: correctiveProcedure?.id, norms },
                        ));
                    }
                    return { analysisType: analysisType?.id, siteControlled, analyticProcedure: analyticProcedure?.id, actions: cleanActions };
                });
                // create an array of empty chart for all in story analysis types ids - analysis types selected in previouse step
                this.chartControleAnalyses.forEach(analysis => charts.push(
                    { ...cloneDeep(this.emptyChart), analysisType: analysis.analysisType.id },
                ));
                // if any of that analysis types has value on mongo replace it
                this.chartsToUpdate = charts.map(obj => cleanCharts?.find(chart => chart.analysisType === obj.analysisType) || obj);
                this.chartsToUpdate.forEach(ch => {
                    if (!ch.actions || ch.actions.length === 0) {
                        ch.actions.push(cloneDeep(this.emptyChart.actions));
                    }
                });
                if (this.chartsToUpdate.length !== this.controlChart.charts?.length) {
                    this.$emit('sendData', { charts: this.chartsToUpdate });
                }
            },
            immediate: true,
        },
    },
    async created() {
        await this.getProcedures();
    },
    methods: {
        async getProcedures() {
            const { data } = await this.$rq.getProcedures({ type: 'analytic', pagination: false });
            this.analyticProcedures = data.procedures;
            const { data: procData } = await this.$rq.getProcedures({ pagination: false });
            this.correctiveProcedures = procData.procedures;
        },
        getChart(analysis) {
            return this.chartsToUpdate.find(ch => ch.analysisType === analysis.analysisType.id);
        },
        updateData({ newData, analysisTypeId }) {
            const index = this.chartsToUpdate.indexOf(this.chartsToUpdate.find(ch => ch.analysisType === analysisTypeId));
            this.chartsToUpdate[index] = newData;
            this.$emit('sendData', { charts: this.chartsToUpdate });
        },
    },
});
</script>
